import { gql } from "@apollo/client";

export const MUTATION_LOGIN = gql`
  mutation login($input: UsersPermissionsLoginInput!) {
    login(input: $input) {
      jwt
      user {
        id
        email
        # username
        # provider
        # confirmed
        # blocked
        # createdAt
        # updatedAt
        # profile
        # onboardHomeCompleted
      }
    }
  }
`;
